import { render } from "./TaskManagement.vue?vue&type=template&id=59b26b03"
const script = {}

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__